import api from "./api";

export function findAll() {
  return new Promise((resolve, reject) => {
    api
      .get("/vendor")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function findBatchSupported() {
  return new Promise((resolve, reject) => {
    api
      .get("/vendor/batch")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
